export function getSectionTitle (type, sectionList){
  return `${type} ` + (sectionList ? `- ${sectionList.length}` : '')
}